module.exports = __webpack_public_path__ + "img/pdf-icon-3.a0a15de6.png";